export const toTitleCase = (str: string) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );

export const nameWithPossesive = (name: string) => {
  if (name.endsWith('s')) return `${name}'`;
  return `${name}'s`;
};

export const getUserPossesivePronoun = (gender: string) => {
  let result = 'their';

  if (gender === 'boy') {
    result = 'his';
  } else if (gender === 'girl') {
    result = 'her';
  }

  return result;
};

export const hasSomeSpecialChar = (input: string) => {
  const REGEX_SOME_SPECIAL_CHAR = /(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/;
  return REGEX_SOME_SPECIAL_CHAR.test(input);
};

export const isValidPassword = (input: string) => {
  // Passwords must be 8 digits and contain one capital letter and one number
  const REGEX_PASSWORD = /(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](.){7,}/;
  return REGEX_PASSWORD.test(input) && hasSomeSpecialChar(input);
};

export const hasCharsForNames = (input: string): boolean => {
  const REGEX_NAME_CHARS = /^[ a-zA-Z-'’‘\s]*$/;
  return REGEX_NAME_CHARS.test(input);
};

export const maskPhoneNumber = (input: string): string => {
  const x = input.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  if (x) {
    return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
  }
  return '';
};

export const maskPhoneNumberOrEmail = (input: string) => {
  const hasFourConsecutiveDigits = /^(\()?\d{3}(\))?/.test(input);

  if (input.length <= 6) {
    return input;
  }

  if (hasFourConsecutiveDigits && input.length > 6) {
    // Apply phone mask and allow only digits
    const x = input.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x) {
      return `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
    }
    return '';
  } else {
    // Input is considered an email
    return input.trim(); // You can add additional email validation logic here if needed
  }
};

export const maskedPhoneToNumber = (input: string): number => {
  const reg = /[\(\)\s-]/g;
  const phone = input.replace(reg, '');
  return parseInt(phone, 10);
};

export const hasOnlyNumbers = (input: string) => {
  const REGEX_ONLY_NUMBERS = /^-?\d+\.?\d*$/;
  return REGEX_ONLY_NUMBERS.test(input);
};

// Helper function to sum array of amount strings -> [$0.00]
export function sumCurrencyValues(
  values: Array<{ goalId: string; value: string }>,
): number {
  const numericValues = values.map(
    (val) => parseFloat((val && val.value.replace('$', '')) || '') || 0,
  );
  const total = numericValues.reduce((sum, value) => sum + value, 0);
  return total;
}
